module.exports = __webpack_public_path__ + "img/green-circle-table-1.85d35eb0.png";